var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-rewards-wrapper"},[_c('DialogPopup',{attrs:{"show":_vm.value,"width":"470px","append-to-body":true}},[_c('MyRewards',{on:{"icon-click":_vm.close}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }